import { createBrowserHistory, createMemoryHistory } from 'history'

export const history = ON_SERVER
    ? createMemoryHistory()
    : createBrowserHistory()
